import { env } from "@repo/env";
import Script from "next/script";

// Route -> GA4 property mapping. Each public marketing route tracks its own
// dedicated GA4 property (provisioned separately), so the mapping lives here in
// one place rather than as literals scattered across the page files. Mounted
// per-page (not in a shared layout) because /researchers and /opportunities
// both live under (marketing)/layout.tsx and each needs a distinct property.
export const ROUTE_GA_IDS = {
  home: "G-YJ2DJNGWQW",
  researchers: "G-1FH4WTVP71",
  login: "G-CNXZQX09G1",
  opportunities: "G-8GVHVPT48Q",
} as const;

// Per-route GA4 property tag. Unlike the site-wide GoogleAnalyticsLoader in the
// root layout (gated on NEXT_PUBLIC_GA_ID), these use hardcoded per-route ids,
// so gating is enforced here: the scripts render only in production, mirroring
// the intent of that gate so preview/dev/CI traffic never reaches the prod
// properties. The inline config <Script> uses a gaId-scoped id so multiple
// properties can coexist on a page without next/script deduping them (a fixed
// id would collapse to a single tag). Mirrors the raw gtag.js pattern Google's
// "Install manually" screen emits, matching the Google Ads block in
// GoogleMarketingTags.
export function RouteGoogleAnalytics({ gaId }: { gaId: string }) {
  if (env.NEXT_PUBLIC_VERCEL_ENV !== "production") {
    return null;
  }

  return (
    <>
      <Script
        strategy="lazyOnload"
        src={`https://www.googletagmanager.com/gtag/js?id=${gaId}`}
      />
      <Script
        id={`gtag-config-${gaId}`}
        strategy="lazyOnload"
        dangerouslySetInnerHTML={{
          __html: `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', '${gaId}');
          `,
        }}
      />
    </>
  );
}
